var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefreshcomponent = function SvgRefreshcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.708 5.792A6.631 6.631 0 0 0 10 3.833 6.658 6.658 0 0 0 3.342 10.5 6.658 6.658 0 0 0 10 17.167c3.108 0 5.7-2.125 6.442-5h-1.734A4.992 4.992 0 0 1 10 15.5c-2.758 0-5-2.242-5-5s2.242-5 5-5a4.93 4.93 0 0 1 3.517 1.483l-2.684 2.684h5.834V3.833l-1.959 1.959Z",
    fill: "#A08264"
  })));
};
export default SvgRefreshcomponent;